import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";


export const SpinnerIndicator: React.FC<{}> = () => (
    <div>
        <FontAwesomeIcon fixedWidth spin icon={faSpinner} />
    </div>
);
